export default {
    name: "home",
    component: () => import(/* home-router-module */ '@/layouts/PrincipalLayout.vue'),
    children: [
        {
            path: "", // Ruta raíz
            name: "home-index", // Nombre correcto
            component: () => import('@/modules/home/views/DefaultPage.vue'),
        },
        {
            path: "dashboard", // Ruta anidada correcta (sin "/")
            name: "dashboard", // Corrige el typo en "dashborad"
            component: () => import('@/modules/home/views/Default2.vue'),
        }      
    ]
}